import { render, staticRenderFns } from "./HeaderContacts.vue?vue&type=template&id=0936e19e&"
import script from "./HeaderContacts.vue?vue&type=script&lang=js&"
export * from "./HeaderContacts.vue?vue&type=script&lang=js&"
import style0 from "./HeaderContacts.vue?vue&type=style&index=0&id=0936e19e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports